import React from 'react'
import {
  Container,
  Header,
  Message,
  Icon,
  Button,
  Menu,
  Label,
} from 'semantic-ui-react'
import {
  Link,
} from 'react-router-dom'
import SelectedItemsTable from './SelectedItemTable'
import SelectionButtonGroup from './SelectionButtonGroup.js'
import SelectionDoesNotExist from './SelectionDoesNotExist';
import EmptySelectionPlaceholder from './EmptySelectionPlaceholder';

class ViewSelection extends React.Component {
  // props: {match, mode, selections, onToggle, onPickSelectionMode}
  computeInitialItemKind = () => {
    const selection = this.props.selections.find(s=>s.id===this.props.match.params.selectionName);
    if (selection) {
      const keys = Object.keys(selection.items);
      const topicCount = keys.filter(k=>k.indexOf('.')>-1).length;
      const outcomeCount = keys.filter(k=>k.indexOf('o')>-1).length;
      if (outcomeCount===0) return 'topics';
      if (topicCount===0) return 'outcomes';
    }
    return 'both';
  }
  state = {
    show: this.computeInitialItemKind()
  }
  handleShow = (itemKind) => {
    this.setState({
      show: itemKind,
    });
  }
  render() {
    const selection = this.props.selections.find(s=>s.id===this.props.match.params.selectionName);
    if (!selection) {
      return <SelectionDoesNotExist id={this.props.match.params.selectionName}/>;
    }
    const keys = Object.keys(selection.items);
    const topicCount = keys.filter(k=>k.indexOf('.')>-1).length;
    const outcomeCount = keys.filter(k=>k.indexOf('o')>-1).length;
    return (
      <Container text style={{ marginTop: '7em', padding: '10px', background: 'white #fef0e7' }}>
        <Header as='h1' style={{color: '#f2711c'}}>
          <SelectionButtonGroup id={selection.id}/>
          <Header.Subheader style={{color: '#f7a56e'}}>Selected Topics &amp; Learning Outcomes</Header.Subheader>
          {selection.name} <span style={{fontWeight: 'lighter', fontVariant: 'all-small-caps'}}>({selection.id})</span>
        </Header>
        {
          keys.length
          ?
          <div>
            <p>
              A selection can contain two different kinds of curriculum items:&nbsp;
              <strong>topics</strong> and <strong>learning outcomes</strong>.
              To view this selection superimposed on the overall curriculum,
              simply <Link to='/areas'>start browsing the knowledge areas</Link>.
            </p>
            <Menu tabular>
              <Menu.Item active={this.state.show==='topics'} onClick={()=>{this.handleShow('topics')}}>
                <Icon name='map marker'/> Topics <Label circular color='green'>{topicCount}</Label>
              </Menu.Item>
              <Menu.Item active={this.state.show==='outcomes'} onClick={()=>{this.handleShow('outcomes')}}>
                <Icon name='trophy'/> Learning Outcomes <Label circular color='green'>{outcomeCount}</Label>
              </Menu.Item>
              <Menu.Item active={this.state.show==='both'} onClick={()=>{this.handleShow('both')}}>
                All Items <Label circular color='green'>{topicCount+outcomeCount}</Label>
              </Menu.Item>
            </Menu>
            <SelectedItemsTable itemKind={this.state.show} mode={this.props.mode} selection={selection} onToggle={this.props.onToggle}/>
            <Message info icon>
              <Icon name='info circle'/>
              <Message.Content>
                <p>
                  Browse or Search to
                  add more items to this selection
                  (by then clicking on the buttons
                  next to each desired topic or learning outcome
                  in the {selection.id} column).
                </p>
                <Button color='orange' as={Link} to='/areas' onClick={this.props.onPickSelectionMode} icon labelPosition='left'><Icon name='world'/> Browse</Button>
                <Button color='orange' as={Link} to='/search' onClick={this.props.onPickSelectionMode} icon labelPosition='left'><Icon name='search'/>Search</Button>
              </Message.Content>
            </Message>
          </div>
          :
          <EmptySelectionPlaceholder onPickSelectionMode={this.props.onPickSelectionMode}/>
        }
      </Container>
    );
  }
}

export default ViewSelection